import { Container, Card, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";

export function CancelledPage() {
  const navigate = useNavigate();

  return (
    <Container className="mt-5 pb-5">
      <Card className="p-4 shadow mx-auto text-center" style={{ maxWidth: "600px" }}>
        <h2 className="mb-4">❌ Payment Cancelled</h2>
        <p className="lead">It looks like your payment was cancelled or didn’t go through.</p>
        <p className="text-muted">If this was a mistake, you can go back and try again.</p>
        <Button 
          onClick={() => navigate("/custom-grad-cake-creator")} 
          style={{ backgroundColor: "#ff5fa2", borderColor: "#ff5fa2" }}
          className="mt-3"
        >
          Try Again
        </Button>
      </Card>
    </Container>
  );
}
